"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _link = _interopRequireDefault(require("./link.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable max-len */


var getJustifyContent = function getJustifyContent(alignHeadlineContainer) {
  switch (alignHeadlineContainer) {
    case 'left':
      return 'flex-start';

    case 'right':
      return 'flex-end';

    case 'center':
      return 'center';

    default:
      return 'flex-start';
  }
};

var LinkContainer = _styledComponents.default.a.withConfig({
  displayName: "Link__LinkContainer",
  componentId: "sc-1gsdbby-0"
})(["display:inline-flex;align-items:center;font-family:", ";font-size:", ";font-weight:", ";color:", ";text-decoration:", ";padding-left:", ";padding-right:", ";text-align:", ";justify-content:", ";", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme.fontSize[size];
}, function (_ref3) {
  var bold = _ref3.bold,
      theme = _ref3.theme;
  return bold ? theme.fontWeight.large : theme.fontWeight.normal;
}, function (_ref4) {
  var theme = _ref4.theme,
      color = _ref4.color;
  return theme.colors[color];
}, function (_ref5) {
  var underlined = _ref5.underlined;
  return underlined ? 'underline' : 'none';
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
}, function (props) {
  return props.alignHeadlineContainer;
}, function (props) {
  return getJustifyContent(props.alignHeadlineContainer);
}, function (_ref6) {
  var hoverUnderlined = _ref6.hoverUnderlined;
  return hoverUnderlined && (0, _styledComponents.css)(["&:hover{text-decoration:underline;}"]);
}, function (_ref7) {
  var hoverColor = _ref7.hoverColor;
  return hoverColor && (0, _styledComponents.css)(["&:hover{color:", ";}"], function (_ref8) {
    var theme = _ref8.theme;
    return hoverColor ? theme.colors[hoverColor] : theme.colors.primary;
  });
});

var Link = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var accessible = props.accessible,
      theme = props.theme,
      href = props.href,
      target = props.target,
      queryParams = props.queryParams,
      size = props.size,
      bold = props.bold,
      color = props.color,
      hoverColor = props.hoverColor,
      className = props.className,
      gtmEventData = props.gtmEventData,
      underlined = props.underlined,
      hoverUnderlined = props.hoverUnderlined,
      customProperties = props.customProperties,
      alignHeadlineContainer = props.alignHeadlineContainer,
      children = props.children,
      type = props.type,
      fireGtm = props.fireGtm,
      callback = props.callback,
      idConfig = props.idConfig;

  var _ref9 = idConfig || {},
      parentName = _ref9.parentName,
      widgetName = _ref9.widgetName,
      index = _ref9.index;

  var _useState = (0, _react.useState)('linkContainer'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'linkContainer';

    if (parentName) {
      url = "".concat(parentName, "-linkContainer");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);
  var tabIndex = !accessible ? '-1' : '0';

  var detectQueryString = function detectQueryString(url) {
    var pattern = new RegExp(/\?.+=.*/g);
    return pattern.test(url);
  };

  var createParams = function createParams() {
    if (!queryParams || JSON.stringify(queryParams) === JSON.stringify({})) {
      return;
    }

    var qParams = ''; // eslint-disable-next-line no-restricted-syntax

    for (var key in queryParams) {
      // eslint-disable-next-line no-prototype-builtins
      if (queryParams.hasOwnProperty(key)) {
        qParams += "".concat(key, "=").concat(queryParams[key], "&");
      }
    }

    qParams = qParams.substring(0, qParams.length - 1); // eslint-disable-next-line consistent-return

    return qParams;
  };

  var formatHref = function formatHref() {
    if (!queryParams || JSON.stringify(queryParams) === JSON.stringify({})) {
      return href;
    }

    var formattedHref = "".concat(href);

    if (!detectQueryString(formattedHref)) {
      formattedHref += '?';
    } else {
      formattedHref += '&';
    }

    formattedHref += createParams();
    return formattedHref;
  };

  var formattedHref = formatHref();
  /** POST method, TBD */

  var postHandler = function postHandler(e) {
    e.preventDefault();
    /**
     * Challenges
     *
     * 1. How do we know the right headers? will it come from the parent / content service
     * 2. How to handle success/error callbacks?
     *     2 possible approaches:
     *        a. Exposed a callback prop so the parent can manipulate the action to be done when POST call is success/fail
     *          (but this will be handled by Hercules)
     *        b. POST api will return the url where we will redirect (Just like deeplink)
     */
    // const payload = createParams();
    // fetch(href, {
    //   method: 'post',
    //   // headers: '', ?
    //   body: payload,
    // })
    //   .then(() => {
    //     if (window) { // ?
    //       window.location(href);
    //     }
    //   })
    //   .catch((error) => {
    //     // eslint-disable-next-line no-console
    //     console.log('Request failed', error);
    //   });
  };

  var gtmHandler = function gtmHandler() {
    return fireGtm && gtmEventData ? fireGtm("".concat(gtmEventData), true) : undefined;
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext); // Default click event handler for Link component

  var handleClick = function handleClick() {
    if (type === _constant.REDIRECTION_TYPE.secured) {
      postHandler();
    } else {
      gtmHandler();
    }
  }; // Fires callback function prop - If target type is callback


  var handleCallback = function handleCallback(event) {
    callback(event);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(LinkContainer, (0, _extends2.default)({
      id: dynamicID,
      ref: ref,
      target: _constant.LINK_TARGET[target].code,
      href: type === _constant.REDIRECTION_TYPE.secured ? '#' : formattedHref,
      size: size,
      bold: bold,
      color: color,
      hoverColor: hoverColor,
      underlined: underlined,
      tabIndex: tabIndex,
      hoverUnderlined: hoverUnderlined,
      onClick: target === 'callback' ? handleCallback : handleClick,
      theme: themeContext,
      alignHeadlineContainer: alignHeadlineContainer,
      className: className
    }, customProperties), children);
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
});
Link.propTypes = _link.default.PropTypes;
Link.defaultProps = _link.default.DefaultProps;
var _default = Link;
exports.default = _default;